import type { AppConfig } from '../../types/global';

/**
 * Возвращает рантайм-конфигурацию приложения.
 *
 * Конфиг подгружается из `/config.js` до основного бандла и попадает
 * в `window.__APP_CONFIG__`. Если по какой-то причине файл не загрузился —
 * бросаем явную ошибку (это лучше тихого fallback'а, который мог бы
 * привести к запросам не в то окружение).
 *
 * @throws Error если `window.__APP_CONFIG__` не определён
 */
export function getConfig(): AppConfig {
  const cfg = typeof window !== 'undefined' ? window.__APP_CONFIG__ : undefined;
  if (!cfg) {
    throw new Error(
      'Runtime config missing: /config.js was not loaded. ' +
        'Check that public/config.js exists (dev) or docker-entrypoint rendered config.js (prod).',
    );
  }
  return cfg;
}
